import React from "react";
import { PROVIDERS, PRICE_NOTE, PHONES, toTel } from "../../mock";

const ProviderCard = ({ provider }) => {
  return (
    <article className="me-card w-[230px] shrink-0 mx-3 rounded-2xl bg-white border border-[#eceef3] shadow-[0_4px_18px_rgba(20,40,76,0.06)] px-5 py-6 flex flex-col items-center text-center transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_10px_28px_rgba(20,40,76,0.12)]">
      <div className="h-14 flex items-center justify-center">
        <img
          src={provider.logo}
          alt={`Logo ${provider.name}`}
          width={140}
          height={70}
          loading="lazy"
          decoding="async"
          className="max-h-12 w-auto object-contain"
        />
      </div>
      <h3 className="mt-3 text-[16px] font-semibold" style={{ color: "var(--me-heading)" }}>
        {provider.name}
      </h3>
      <div className="mt-1.5 text-[15px] font-medium" style={{ color: "var(--me-text)" }}>
        <span>{provider.price}</span>
        {provider.hasStar && <sup className="text-[var(--me-orange)]">*</sup>}
      </div>
      <a
        href={toTel(PHONES.compare)}
        aria-label={`Comparer l'offre ${provider.name}, appeler le ${PHONES.compare}`}
        className="mt-4 rounded-full px-6 py-2 text-white text-[14px] font-semibold transition-colors"
        style={{ backgroundColor: "var(--me-sky)" }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-sky-hover)")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-sky)")}
      >
        Je compare
      </a>
    </article>
  );
};

const ProviderCarousel = () => {
  const loop = [...PROVIDERS, ...PROVIDERS];
  return (
    <div className="mt-10">
      <div className="relative overflow-hidden rounded-2xl border border-[#eceef3] bg-[#fbfcfe] py-6">
        <div className="me-marquee-track">
          {loop.map((p, i) => (
            <ProviderCard key={`${p.id}-${i}`} provider={p} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#fbfcfe] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#fbfcfe] to-transparent" />
      </div>
      <p className="mt-5 text-[12.5px] leading-relaxed text-center max-w-3xl mx-auto" style={{ color: "#8a8f98" }}>
        <sup className="text-[var(--me-orange)]">*</sup> {PRICE_NOTE}
      </p>
    </div>
  );
};

export default ProviderCarousel;
